import { YOUTUBE, SOUNDCLOUD } from '@/utils/constants';

const providerKeys = {
    all: () => [{ entity: 'provider' }],
    allLists: () => [{ ...providerKeys.all()[0], scope: 'list' }],
    listByShowId: (rawShowId) => [{ ...providerKeys.allLists()[0], showId: Number(rawShowId) }],
    allDetails: () => [{ ...providerKeys.all()[0], scope: 'detail' }],
    detailForYoutube: (rawShowId) => [
        { ...providerKeys.allDetails()[0], showId: Number(rawShowId), provider: YOUTUBE },
    ],
    detailForSoundcloud: (rawShowId) => [
        { ...providerKeys.allDetails()[0], showId: Number(rawShowId), provider: SOUNDCLOUD },
    ],
};

export default providerKeys;
